import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageHandlerService {
  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private translateService: TranslateService
  ) {}

  /**
   * @returns Current language.
   */
  get currentLang() {
    return this.translateService.currentLang;
  }

  /**
   * @returns Observable that listens to language change.
   */
  get onLangChange() {
    return this.translateService.onLangChange;
  }

  /**
   * Method to change language globally.
   * @param langCode - Code of the language.
   * @param [alterConfig=true] - Whether to store the changed language config or not (by default "true").
   * @returns Observable that handles language change request.
   */
  changeLanguage(langCode: string, alterConfig = true) {
    return this.translateService.use(langCode).pipe(
      tap({
        next: () => {
          if (isPlatformServer(this.platformId) || !alterConfig) {
            return;
          }

          localStorage.setItem(
            'langDate',
            JSON.stringify({ lang: langCode, Date: new Date().toISOString() })
          );
        },
      })
    );
  }

  /**
   * Method to fetch any language config (langDate) object & set language initially.
   */
  setDefaulLanguage() {
    let savedLang = 'en';

    if (isPlatformServer(this.platformId)) {
      return this.changeLanguage(savedLang);
    }

    try {
      const savedLangConfig = localStorage.getItem('langDate');
      const { lang } = JSON.parse(savedLangConfig!);
      savedLang = lang;
    } catch (error) {
      console.log('Error in fetching saved language config');
    } finally {
      return this.changeLanguage(savedLang);
    }
  }
}
